import React, { useEffect, useState } from "react";

import { Alert, Container } from "@mui/material";
import { useJwtStorage, useLocalStorage } from "../../hooks/useLocalStorage";
import Button from "@mui/material/Button";

import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";
import TableContainer from "@mui/material/TableContainer";

import DrawerAppBar from "../../components/DrawerAppBar";
import Title from "../../components/Title";
import ProgressBar from "../../components/ProgressBar";

import { doService } from "../../services/ServiceHelper";


import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import {ReactComponent as ExpandMoreIcon} from "../../icons/ExpandMore24.svg";

import AccordionTitle from "../../components/AccordionTitle";
import TableRowNoResults from "../../components/TableRowNoResults";
import { adminPassGetExcludedStudents } from "../../services/PassService";

import {
  StripedTableCell,
  StripedTableRow,
} from "../../components/StripedTable";

const FacultyExcludeStudentsPass = () => {
  const [_school] = useLocalStorage("Auth", "school", null);
  const [_jwt] = useJwtStorage();
  const [_showProgress, setShowProgress] = useState(false);

  const [_results, setResults] = useState([]);

  // student eids to validate if already in there
  const [_allStudentEidsMap, setAllStudentEidsMap] = useState({});

  useEffect(() => {
    initList();
  }, []);

  const initList = () => {
    setShowProgress(true);
    doService(adminPassGetExcludedStudents(_school, _jwt), (result) => {
      setResults(result.data);
      setShowProgress(false);

      const map = {};
      for (const student of result.data) {
        map[student.eid] = student;
      }
      setAllStudentEidsMap(map);
    });
  };

  return (
    <>
      <DrawerAppBar />

      <Container sx={{ mt: 1 }}>
        <Title text="Excluded Student Passes" showBack={true} />
        <ProgressBar showProgress={_showProgress} />

        <Alert severity="info">
          The students below will not be able to create passes, or have passes created for them,
          unless performed by an administrator.
        </Alert>

        <Accordion defaultExpanded sx={{ mt: 1 }}>
          <AccordionSummary
            className="accordionHeader"
            expandIcon={<ExpandMoreIcon />}
          >
            <AccordionTitle
              text={`Students Excluded (${_results.length})`}
            />
          </AccordionSummary>
          <AccordionDetails>
            <TableContainer component={Paper} sx={{ mt: 1, mb: 2 }}>
              <Table size="small">
                <TableHead>
                  <StripedTableRow>
                    <StripedTableCell>Name</StripedTableCell>
                    <StripedTableCell align="center">Grade</StripedTableCell>
                  </StripedTableRow>
                </TableHead>
                <TableBody>
                  <TableRowNoResults data={_results} />

                  {_results.map((result) => (
                    <StripedTableRow>
                      <StripedTableCell>
                        {result.last_name}, {result.first_name}
                      </StripedTableCell>
                      <StripedTableCell align="center">
                        {result.grade}
                      </StripedTableCell>
                    </StripedTableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>{" "}
          </AccordionDetails>
        </Accordion>
      </Container>

    </>
  );
};

export default FacultyExcludeStudentsPass;
